 

export const links = [
    {
    id: 1,
    url: '/',
    text: 'Home',
    },
    {
        id: 2,
        url:'/login',
        text:'Login',
    },
    {
        id: 3,
        url:'/axiosexample',
        text:'Jokes API',
    },
    {
        id:4,
        url:'/examplepage',
        text:'Heroes',
    },
    {
        id:5,
        url:'/products',
        text:'Books',
    },
    {
        id:6,
        url:'/testpage',
        text:'Window Size',
    },
    {
        id:7,
        url:'/about',
        text:'Counter',
    },
    {
        id:8,
        url:'/simplecrm',
        text:'CRM',
    },
    {
        id:9,
        url:'/cocobook',
        text:'Coco',
    },
    {
        id:10,
        url:'/grocerylist',
        text:'Grocery List',
    }

];